import React from 'react';
import styled from 'styled-components';

import { SimpleSelect } from '../../../shared/layout/forms/AppSelect';
import { StyledInput, StyledLabel, FormGroup, ErrorText } from '../../../shared/layout/forms/FormElements';

/**
 * Forma nacrtana iz `config_schema` adaptera.
 *
 * Poanta: adapter opisuje svoja polja na serveru, a sučelje ih samo iscrta.
 * Kad se doda šesti izvor, ovdje se ne mijenja ništa — inače bi svaki novi tip
 * feeda tražio novi ekran.
 */
const SchemaForm = ({ schema, values, errors = {}, onChange }) => {
    const visible = (field) => {
        const dependsOn = field.depends_on;
        if (!dependsOn) return true;

        return Object.entries(dependsOn).every(([key, expected]) => values[key] === expected);
    };

    const set = (key, value) => onChange({ ...values, [key]: value });

    return (
        <>
            {Object.entries(schema || {}).map(([key, field]) => {
                if (!visible(field)) return null;

                const value = values[key] ?? field.default ?? '';
                const error = errors[key];

                return (
                    <FormGroup key={key}>
                        <StyledLabel>
                            {field.label || key}
                            {field.required && <Required>*</Required>}
                        </StyledLabel>

                        {field.type === 'select' ? (
                            <SimpleSelect value={value} onChange={(e) => set(key, e.target.value)}>
                                {Object.entries(field.options || {}).map(([optionValue, optionLabel]) => (
                                    <option key={optionValue} value={optionValue}>{optionLabel}</option>
                                ))}
                            </SimpleSelect>
                        ) : (
                            <StyledInput
                                type={field.type === 'secret' ? 'password' : 'text'}
                                value={value}
                                placeholder={field.placeholder || ''}
                                $error={Boolean(error)}
                                onChange={(e) => set(key, e.target.value)}
                            />
                        )}

                        {field.help && !error && <Help>{field.help}</Help>}
                        {error && <ErrorText>{error}</ErrorText>}
                    </FormGroup>
                );
            })}
        </>
    );
};

const Required = styled.span`
    color: #dc3545;
    margin-left: 0.2rem;
`;

const Help = styled.p`
    margin: 0.3rem 0 0;
    font-size: 0.78rem;
    opacity: 0.65;
`;

export default SchemaForm;
